<template>
  <div>
    <div class="message" ref="messageDisplay">
      <message v-for="m in messages" :key="m.id" :message="m" />
    </div>
    <div class="control">
      <div>
        <div class="control-textarea">
          <input
            v-on:keyup.enter="send"
            placeholder="..."
            type="text"
            v-model="text"
          />
        </div>
        <div class="control-buttons">
          <button @click="send">{{ "send" | setText("Отправить") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import message from "@/components/Pupils/Chat/Message";
import { getMessages, sendMessage } from "@/_api/apiPupil";
import { mapState } from "vuex";
export default {
  props: {
    chat_id: {
      default: null,
    },
  },
  computed: {
    ...mapState(["message"]),
  },
  components: {
    message,
  },
  methods: {
    sendMessage: sendMessage,
    getMessages: getMessages,
    scrollBottom(delay) {
      setTimeout(() => {
        let messageDisplay = this.$refs.messageDisplay;
        messageDisplay.scrollTop = messageDisplay.scrollHeight;
      }, delay);
    },

    send() {
      this.sendMessage(this.chat_id, this.text);
    },
  },
  created() {
    this.getMessages(this.chat_id);
  },
  watch: {
    chat_id(val) {
      this.getMessages(val);
    },
    message: {
      handler: function (val) {
        if (val && val[this.chat_id]) {
          this.messages.push(val[this.chat_id]);
          this.scrollBottom(100);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      messages: [],
      text: "",
    };
  },
};
</script>
<style lang="scss">
</style>
